export class Notification {
    status?: boolean = false;
    text: string;
    icon: string;
    cssClass: string;
  
    constructor(notification: Notification) {
      this.set(notification);
    }
  
    set?(notification: Notification) {
      if (notification !== undefined) {
        this.status = true;
        this.text = notification.text;
        this.icon = notification.icon;
        this.cssClass = notification.cssClass;
      }
    }
  
  }


// WEBPACK FOOTER //
// ./src/app/notification/shared/notification.model.ts